export default __webpack_public_path__ + "static/media/carson-project-1.6c7858c4.jpg";